module.exports = __webpack_public_path__ + "static/img/help_07paper_01.bed4ed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_07paper_01.png
// module id = 701
// module chunks = 140